import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./src/taskpane/translation/translation_en.json";
import de from "./src/taskpane/translation/translation_de.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: "de", // Default language
  fallbackLng: "de", // Fallback language if translation is missing
  interpolation: { escapeValue: false }, // React already escapes values
});

export default i18n;
